
/**
 * Module dependencies.
 */

import { kioskRoutes } from './routes';

/**
 * Export `Size` type.
 */

export type Size = 'medium' | 'small';

/**
 * Export `Menu` type.
 */

export type Menu = {
  hasMargin?: boolean,
  href?: string | null,
  size?: Size,
  title: string
};

/**
 * Export `kioskMenu`.
 */

export const kioskMenu: Menu[] = [{
  href: kioskRoutes.collections,
  size: 'medium',
  title: 'menu:productsMenu.collections'
}, {
  href: kioskRoutes.highlights,
  size: 'medium',
  title: 'menu:productsMenu.highlights'
}, {
  hasMargin: true,
  href: kioskRoutes.inspiration,
  size: 'medium',
  title: 'menu:getInspiredMenu.ambients'
}, {
  href: kioskRoutes.recommend,
  title: 'menu:productsMenu.recommender'
}, {
  // eslint-disable-next-line no-script-url
  href: 'javascript:roomvo.startStandaloneVisualizer();',
  title: 'menu:toolsMenu.arDesignKiosk'
}, {
  hasMargin: true,
  href: kioskRoutes.portfolio,
  title: 'menu:getInspiredMenu.portfolio'
}, {
  href: kioskRoutes.aboutUs,
  title: 'menu:revigresMenu.aboutUs'
}, {
  href: kioskRoutes.history,
  title: 'menu:revigresMenu.history'
}, {
  href: kioskRoutes.innovation,
  title: 'menu:revigresMenu.innovation'
}, {
  href: kioskRoutes.environment,
  title: 'menu:revigresMenu.environmentSustainability'
}, {
  hasMargin: true,
  href: kioskRoutes.socialResponsability,
  title: 'menu:revigresMenu.socialResponsability'
}, {
  href: kioskRoutes.contacts,
  title: 'menu:contacts'
}];

/**
 * Export `kioskNavbarLinks`.
 */

export const kioskNavbarLinks = [{
  label: 'menu:toolsMenu.arDesignKiosk',
  // eslint-disable-next-line no-script-url
  link: 'javascript:roomvo.startStandaloneVisualizer();'
}, {
  label: 'menu:productsMenu.collections',
  link: kioskRoutes.collections
}, {
  label: 'menu:ambients',
  link: kioskRoutes.inspiration
}, {
  label: 'menu:getInspiredMenu.portfolio',
  link: kioskRoutes.portfolio
}];

